import { render, staticRenderFns } from "./ProdEpiInToday.vue?vue&type=template&id=c6d95a08&scoped=true&"
import script from "./ProdEpiInToday.vue?vue&type=script&lang=js&"
export * from "./ProdEpiInToday.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6d95a08",
  null
  
)

export default component.exports